import Konva from 'konva/konva'
import AnalogueVariable from './analogue-variable'
import CategoryVariable from './category-variable'
import { decimate } from '../data-decimation'
import { timeToX } from '../utils'
import i18n from "../../../i18n";

const futureLine = { color: 'rgba(0,0,0,0.87)', width: 3 }
const assetOffset = 25

export default class VariableLayer extends Konva.Layer {
  constructor ({ name, redraw }) {
    super({ name })
    Object.assign(this, { redraw })
  }

  init ({ width, yOffset, timeFrom, timeTo, now, data, userData }) {
    Object.assign(this, { width, yOffset, yFrom: yOffset, timeFrom, timeTo, now, data, userData })

    this._render()
  }

  _render () {
    this.destroyChildren()

    this._calculateNowX()

    this.variables = []
    this.titleData = []
    this.resizeHandleData = []
    this.yScaleData = []
    this.data.forEach(asset => {
      this.titleData.push({ asset, yOffset: this.yOffset })
      this.yOffset += assetOffset

      if (!asset.variables.length) {
        this.titleData.push({ error: i18n.t('logs.no-data-available'), yOffset: this.yOffset })
        this.yOffset += assetOffset * 2
        return
      }

      asset.variables
        .filter(variable => variable.type !== 'event')
        .forEach(variable => {
          this._renderVariable(asset, variable)
        })
    })

    this._renderFutureLine()

    this.draw()
  }

  _calculateNowX () {
    const { width, timeFrom, timeTo, now } = this
    this.nowX = timeToX({ timeFrom, timeTo, width, time: now })
  }

  _createVariable (asset, variableConfig) {
    const { width, yOffset, timeFrom, timeTo, now, nowX, resizeHandleData, yScaleData, userData, redraw } = this
    const { values, name, config } = variableConfig
    const decimatedValues = decimate({ timeFrom, timeTo, width, values })

    const userDataKey = asset.id + '|' + name
    const variableUserData = { ...userData.variables[userDataKey] }
    userData.variables[userDataKey] = variableUserData

    const params = {
      width,
      yOffset,
      timeFrom,
      timeTo,
      now,
      nowX,
      name,
      config,
      values: decimatedValues,
      resizeHandleData,
      yScaleData,
      variableUserData,
      redraw
    }

    switch (variableConfig.type) {
      case 'category':
        return new CategoryVariable(params)
      case 'analog':
        return new AnalogueVariable(params)
    }
    throw new Error('Unknown variable type: ' + variableConfig.type)
  }

  _renderVariable (asset, variableConfig) {
    const variable = this._createVariable(asset, variableConfig)

    variable.render()
    this.add(variable)
    this.variables.push(variable)

    this.titleData.push({ asset, variable, variableConfig, yOffset: this.yOffset })

    this.yOffset += variable.height
  }

  _renderFutureLine () {
    const { width, yFrom, yOffset, nowX } = this

    if (width > nowX) {
      this.add(new Konva.Line({
        points: [nowX, yFrom, nowX, yOffset],
        stroke: futureLine.color,
        strokeWidth: futureLine.width
      }))
    }
  }
}
